var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabpage-content as-flex main-start cross-center" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "tab-row",
          attrs: {
            type: "card",
            value: _vm.currentTab ? _vm.currentTab.statusCode : undefined,
            closable: "",
          },
          on: { "tab-remove": _vm.removeTab, "tab-click": _vm.handleClick },
        },
        _vm._l(_vm.tabs, function (item, index) {
          return _c("el-tab-pane", {
            key: item.statusCode + index,
            attrs: { label: item.title, name: item.statusCode },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }